import api from './client'

export interface SessionCreate {
  name: string
  corpus_id: string
}

export interface SessionResponse {
  session_id: string
  user_id: string
  corpus_id: string | null
  name: string
  created_at: string
  updated_at: string
}

export const sessionApi = {
  create: (data: SessionCreate) => api.post<SessionResponse>('/sessions', data),
  list: (corpusId?: string) =>
    api.get<SessionResponse[]>('/sessions/my', corpusId ? { params: { corpus_id: corpusId } } : undefined),
  get: (id: string) => api.get<SessionResponse>(`/sessions/${id}`),
  update: (id: string, data: Partial<{ name: string }>) => api.put<SessionResponse>(`/sessions/${id}`, data),
  delete: (id: string) => api.delete(`/sessions/${id}`),
}
